import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import axios from 'axios';
import config from '../config/ConfigProvider';
import EditEpubGuideDialog from "@/components/epubguide/EditEpubGuideDialog.vue";
import EditMultipleEpubGuideDialog from "@/components/epubguide/EditMultipleEpubGuideDialog.vue";
import CreateNewEpubForm from "@/components/epubguide/CreateNewEpubForm.vue";
import {
  EpubStorable,
  ExecutionInfo, GetEpubDownloadLinkRequest, GetEpubDownloadLinkResponse,
  GetEpubsResponse, GetExecutionInfoRequest,
  ListExecutionsResponse
} from "@ilteducation/epub-guide-generator-types";


export default /*#__PURE__*/_defineComponent({
  __name: 'EpubGuideGenerator',
  setup(__props) {

const epubs = ref<GetEpubsResponse[]>();
const executions = ref<ExecutionInfo[]>();
const selectedEpubs = ref<GetEpubsResponse[]>([]);

onMounted(() => {
  axios.get(`${config.value('epubGuideGeneratorUrl')}/getEpubs`).then((response) => {
    if(response.data.type === 'SuccessResponseV1') {
      epubs.value = response.data.payload as GetEpubsResponse[];
    }
  });
  axios.get(`${config.value('epubGuideGeneratorUrl')}/getExecutions`).then((response) => {
    if(response.data.type === 'SuccessResponseV1') {
      console.log(response.data.payload);
      executions.value = (response.data.payload as ListExecutionsResponse).executions;
    }
    if(!executions.value) {
      return;
    }
    const promises = executions.value.map((execution) => {
      if (execution.status === 'FAILED') {
        const data: GetExecutionInfoRequest = {
          key: execution.name,
        };
        return axios
          .post(`${config.value('epubGuideGeneratorUrl')}/getExecutionInfo`, data)
          .then((res) => {
            if (res.data.type === 'SuccessResponseV1') {
              return ({ ...execution, cause: res.data.payload.cause });
            }
            return ({ ...execution, cause: 'Unknown error' });
          });
      }
      return Promise.resolve(execution); // Wrap non-promise values in a resolved promise
    });

    Promise.all(promises).then((updatedExecutions) => {
      executions.value = updatedExecutions;
    });
  });
});

const headers = [
  { text: 'Epub file name', value: 'body.fileName' },
  { text: 'Language', value: 'body.language'},
  { text: 'Created', value: 'createdAt' },
  { text: 'Last modified', value: 'lastModifiedAt' },
  { text: 'Download', value: 'url' },
  { text: 'Edit', value: 'edit' },
];
const headersExecutions = [
  { text: 'Name', value: 'name' },
  { text: 'Start date', value: 'startDate' },
  { text: 'Status', value: 'status' },
  { text: 'Message', value: 'cause' },
];

const downloadEpub = async (epub: EpubStorable) => {
  const data: GetEpubDownloadLinkRequest = {
    entityId: epub.id,
    fileName: epub.body.fileName,
  };
  const res = await axios.post(`${config.value('epubGuideGeneratorUrl')}/getEpubDownloadLink`, data);
  if (res.data.type !== 'SuccessResponseV1') {
    console.error('Failed to get download link');
    return;
  }
  const { downloadLink }: GetEpubDownloadLinkResponse = res.data.payload;
  window.open(downloadLink);
};


return { __sfc: true,epubs, executions, selectedEpubs, headers, headersExecutions, downloadEpub, EditEpubGuideDialog, EditMultipleEpubGuideDialog, CreateNewEpubForm }
}

})